// extracted by mini-css-extract-plugin
module.exports = {"halfdonut_progress":"style_halfdonut_progress__jgyTy","progress":"style_progress__3tS-c"};